
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 16.5a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0112 16.5zm0-6a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0112 10.5zm0-6a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0112 4.5z"}})])
          )
        }
      }
    